import React from "react";
import {
  FiSearch,
  FiUser,
} from "react-icons/fi";

const Navbar = () => {
  return (
    <div className="topbar">
      {/* <div className="search-box">
        <FiSearch />

        <input
          type="text"
          placeholder="Search requirement..."
        />
      </div> */}

      <div className="topbar-right">
        <div className="profile-box">
          <FiUser />
          {/* <span>Admin</span> */}
        </div>
      </div>
    </div>
  );
};

export default Navbar;